import { Button, Input, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import AddIcon from "../../../assets/icons/AddIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import ViewFeedbackDetails from "../../../components/FeedbackDetails/ViewFeedbackDetails";
import CustomTable from "../../../components/ui/CustomTable";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { countParPageSerialNumber } from "../../../utils/number";
import { addKeyInArray } from "../../../utils/utils";

export const leaveSettingsTabList = [
  {
    label: "digiGo",
    link: "/admin/feedback",
  },
  {
    label: "Ticketing",
    link: "/",
  },
  {
    label: "Sheba Pay",
    link: "/",
  },
  {
    label: "Sheba xyz",
    link: "/",
  },
];

enum Status {
  Resolved = "Resolved",
  Open = "Open",
}

export default function Feedback() {
  const { open, handleOpen, handleClose } = useModal();
  const { page, limit, handlePagination, handleLimit } = useTable();

  const columns: ColumnsType<LeaveDataType> = [
    {
      title: "#SL",
      dataIndex: "index",
      align: "center",
      width: 50,
      render: (_: any, __: any, index: number) =>
        countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Client Id",
      dataIndex: "clientId",
    },
    {
      title: "Company Name",
      dataIndex: "title",
    },
    {
      title: "Email Address",
      dataIndex: "email",
    },
    {
      title: "Feedback",
      dataIndex: "Feedback",
    },
    {
      title: "Created at",
      dataIndex: "date",
    },

    {
      title: "Status",
      dataIndex: "status",
      render: (value: keyof typeof Status) => (
        <span
          className={`${value === "Open" ? "status-warning" : "status-dark"}`}
        >
          {value}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "key",
      align: "center",
      render: (val) => (
        <Space size={8}>
          <Button
            icon={<EditIcon />}
            size="small"
            className="action-button"
            onClick={() =>
              handleOpen({
                type: "UPDATE",
                data: val,
              })
            }
          />
          <Button
            icon={<DeleteIcon />}
            size="small"
            className="action-button"
            danger
          />
        </Space>
      ),
    },
  ];

  return (
    <SidebarLayout title="Leave Settings" tabList={leaveSettingsTabList}>
      <CustomTable
        loading={false}
        limit={limit}
        page={page}
        columns={columns}
        total={100}
        dataSource={addKeyInArray(data)}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input suffix={<SearchIcon />} placeholder="Search" />

            <Button
              className="middle-button"
              type="primary"
              icon={<AddIcon />}
              onClick={() =>
                handleOpen({
                  type: "ADD",
                })
              }
            >
              Add New Leave
            </Button>
          </>
        }
      />

      {open.type === "ADD" && (
        <ViewFeedbackDetails
          open={open.open}
          type={open.type}
          data={open.data}
          handleClose={handleClose}
        />
      )}
    </SidebarLayout>
  );
}

interface LeaveDataType {
  key: string;
  title: string;
  clientId: string;
  email: string;
  Feedback: string;
  date: string;
  status: string;
}

const data: LeaveDataType[] = [
  {
    key: "1",
    title: "upka",
    clientId: "XYZ251",
    email: "name@gmail.com",
    Feedback: "Text go here",
    date: "10 Jan, 2025",
    status: "Open",
  },
  {
    key: "2",
    title: "upka",
    clientId: "XYZ251",
    email: "name@gmail.com",
    Feedback: "Text go here",
    date: "10 Jan, 2025",
    status: "Resolved",
  },
  {
    key: "3",
    title: "upka",
    clientId: "XYZ251",
    email: "name@gmail.com",
    Feedback: "Text go here",
    date: "10 Jan, 2025",
    status: "Resolved",
  },
  {
    key: "4",
    title: "upka",
    clientId: "XYZ251",
    email: "name@gmail.com",
    Feedback: "Text go here",
    date: "10 Jan, 2025",
    status: "Open",
  },
];
